export const VALUE_CONSTANTS = {

  RENTAL_TYPES: {
    PROPERTY: 'PROPERTY',
    CAR: 'CAR',
    TOUR: 'TOUR',
  },

  LOCAL_STORAGE_KEYS: {
    ACCESS_TOKEN: "accessToken-v1",
    COUNTRY: "country-v1",
    CURRENCY: "currency-v1",
    LANGUAGE: "language-v1",
  },

  DATE: {
    UTC_FORMAT: 'YYYY-MM-DDTHH:mm:ss.SSS[Z]',
    URL_FORMAT: 'DD-MM-YYYY',
    DATE_OF_BIRTH_FORMAT: "DD.MM.YYYY",
  },

  POSITION_ICON_BTN: {
    START: "START",
    END: "END",
  },

  FORM_FIELDS: {
    AUTH: {
      PHONE_NUMBER_FIELD: "phoneNumber",
      OTP_FIELD: "otp",
    },
    USER: {
      FIRST_NAME_FIELD: "firstName",
      LAST_NAME_FIELD: "lastName",
      EMAIL_FIELD: "email",
      DATE_OF_BIRTH_FIELD: "dateOfBirth",
    },
    FOR_SOMEONE: {
      FOR_NAME_FIELD: "bookingForName",
      FOR_SURNAME_FIELD: "bookingForSurname",
      FOR_EMAIL_FIELD: "bookingForEmail",
      FOR_DATE_OF_BIRTH_FIELD: "bookingForDob",
    },
  },

  ID_PORTS_CSS: {
    LAYOUT_PORT: 'LAYOUT_PORT',
  }

  // SEARCH_PARAMS: {
  //   AREA_ID: 'areaId',
  //   ADULTS: 'adults',
  //   CHILDREN: 'children',
  //   INFANTS: 'infants',
  //   BED_ROOMS: 'bedRooms',
  //   CHECK_IN: 'checkIn',
  //   CHECK_OUT: 'checkOut',
  // },

};